/* eslint-disable no-unused-vars */
import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import './css/SeaonPlayersAndCoaches1.css';
import { context } from '../../../globalState/GlobalState';
import Spinner1 from '../../uiElements/spinners/spinner1/Spinner1';
import BreadCrumbs1 from '../../uiElements/breadCrumbs/breadCrumbs1/BreadCrumbs1';
import RostersComponent1 from '../../uiElements/rostersComponents/rostersComponent1/RostersComponent1';
import PlayerThumbnail1 from '../../uiElements/playerAndCoachThumbnails/playerThumbnails/playerThumbnail1/PlayerThumbnail1';
import CoachThumbnail1 from '../../uiElements/playerAndCoachThumbnails/coachThumbnails/coachThumbnail1/CoachThumbnail1';
import Title1 from '../../uiElements/title/title1/Title1';
import { isValidObject, isValidString } from '../../../catalog/Validity';
import { getPlayerInfo } from '../../../catalog/Website';

const SeasonPlayersAndCoaches1 = (props) => {
    const { players, coaches, seasonName, mainLoadingSpinner, rosterLoadingSpinner, coachesLoadingSpinner } = props;
    const { globalState } = useContext(context);

    const getBreadCrumbsLinks = () => {
        return [
            {
                title: 'Home',
                link: '/',
            },
        ];
    };

    return (
        <>
            {mainLoadingSpinner ? (<Spinner1 color={globalState.websiteStyles.colors.primaryColor} />) : (
                <>
                    <BreadCrumbs1 links={getBreadCrumbsLinks()} lastCrumb="Roster And Coaches" marginLeft="100px" />
                    <div className="players1-container x-center bg-white curve-border-30px box-shadow-black p-t-20px p-l-100px p-r-100px p-b-100px m-t-50px m-b-30px">
                        <Title1 title={`Roster ${seasonName}`} />
                        <div className="players1">
                            {rosterLoadingSpinner ? (<Spinner1 color={globalState.websiteStyles.colors.primaryColor} />) : (
                                <>
                                    {players.length > 0 ? (
                                        <>
                                            {players.sort((playerA, playerB) => {
                                                return ((parseInt(getPlayerInfo(playerA.details, 'Team Number'), 10) > parseInt(getPlayerInfo(playerB.details, 'Team Number'), 10)) ? 1 : ((parseInt(getPlayerInfo(playerB.details, 'Team Number'), 10) > parseInt(getPlayerInfo(playerA.details, 'Team Number'), 10)) ? -1 : 0));
                                            }).map((player) => {
                                                return (
                                                    <React.Fragment key={player.id}>
                                                        <PlayerThumbnail1 player={player} />
                                                    </React.Fragment>
                                                );
                                            })}
                                        </>
                                    ) : (<p className="alegreya-font-family font-weight-800 font-size-4xl full-width text-center-align">Roster Unavailable</p>)}
                                </>
                            )}
                            {isValidObject(globalState.logo) && isValidString(globalState.logo.logo2) ? (
                                <img src={globalState.logo.logo2} className="players1-icon m-t-50px m-b-0" alt={isValidString(globalState.teamName) ? globalState.teamName : 'Team Logo'} />
                            ) : null}
                        </div>
                    </div>
                    <div className="players1-container x-center bg-white curve-border-30px box-shadow-black p-t-20px p-l-100px p-r-100px p-b-100px m-t-50px m-b-30px">
                        <Title1 title={`Coaches ${seasonName}`} useH1={false} />
                        <div className="players1">
                            {coachesLoadingSpinner ? (<Spinner1 color={globalState.websiteStyles.colors.primaryColor} />) : (
                                <>
                                    {coaches.length > 0 ? (
                                        <>
                                            {coaches.map((coach) => {
                                                return (
                                                    <React.Fragment key={coach.id}>
                                                        <CoachThumbnail1 coach={coach} />
                                                    </React.Fragment>
                                                );
                                            })}
                                        </>
                                    ) : (<p className="alegreya-font-family font-weight-800 font-size-4xl full-width text-center-align">Coaches Unavailable</p>)}
                                </>
                            )}
                            {isValidObject(globalState.logo) && isValidString(globalState.logo.logo2) ? (
                                <img src={globalState.logo.logo2} className="players1-icon m-t-50px m-b-0" alt={isValidString(globalState.teamName) ? globalState.teamName : 'Team Logo'} />
                            ) : null}
                        </div>
                    </div>
                    <div className="players1-other-roster-container x-center m-t-40px">
                        <RostersComponent1 />
                    </div>
                </>
            )}
        </>
    );
};

SeasonPlayersAndCoaches1.propTypes = {
    players: PropTypes.array.isRequired,
    coaches: PropTypes.array.isRequired,
    seasonName: PropTypes.string.isRequired,
    mainLoadingSpinner: PropTypes.bool.isRequired,
    rosterLoadingSpinner: PropTypes.bool.isRequired,
    coachesLoadingSpinner: PropTypes.bool.isRequired,
};

export default memo(SeasonPlayersAndCoaches1);
